import { CSSProperties, ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface TrProps {
  isClickable?: boolean;
  transform?: string | null;
  transition?: string | null;
  fullWidth?: boolean;
  isEven?: boolean;
  isOdd?: boolean;
  borderBottom?: boolean;
  isRowSelected?: boolean;
  isStaticRow?: boolean;
  isDeleted?: boolean;
  isEmpty?: boolean;
  rowHeight?: number;
  children?: ReactNode;
  onClick?: any;
  style?: CSSProperties;
  className?: string;
  role?: string;
  ref?: any;
}

export const Tr = styled.div<TrProps>`
  cursor: default;
  padding: 0 25px;
  background-color: ${({ theme }) => theme.palette.backgrounds.evenRow};
  color: ${({ theme }) => theme.palette.neutral.darkest};

  ${({ isClickable }) =>
    isClickable &&
    css`
      cursor: pointer;
    `}

  ${({ transform }) =>
    transform &&
    css`
      transform: ${transform};
    `}

  ${({ transition }) =>
    transition &&
    css`
      transition: ${transition};
    `}

  ${({ fullWidth }) =>
    !fullWidth &&
    css`
      width: fit-content;
    `}

  ${({ isEven, theme }) =>
    isEven &&
    css`
      background-color: ${theme.palette.backgrounds.evenRow};
    `}

  ${({ isOdd, theme }) =>
    isOdd &&
    css`
      background-color: ${theme.palette.backgrounds.oddRow};
    `}

  ${({ borderBottom }) =>
    borderBottom &&
    css`
      border-bottom: ${({ theme }) => `1px solid ${theme.palette.tableBorderColor}`};
    `}

  ${({ isRowSelected, theme }) =>
    isRowSelected &&
    css`
      background-color: ${theme.colors.tableSelection};
      border-color: ${theme.colors.tableSelection};
      color: ${theme.palette.text.secondary};

      a {
        color: ${theme.palette.text.secondary} !important;
      }
    `};

  ${({ isRowSelected, isStaticRow, theme }) =>
    !isRowSelected &&
    !isStaticRow &&
    css`
      &:hover {
        background-color: ${theme.palette.backgrounds.hoverRow};
      }
    `};

  ${({ isDeleted, isRowSelected }) =>
    isDeleted &&
    css`
      text-decoration: line-through;
      color: ${({ theme }) =>
        isRowSelected ? theme.palette.text.secondary : theme.palette.text.placeholder};

      a {
        color: ${({ theme }) =>
          isRowSelected ? theme.palette.text.secondary : theme.palette.text.placeholder};
        cursor: default;

        :hover {
          text-decoration: none;
        }
      }

      span {
        text-decoration: line-through;
        color: ${({ theme }) =>
          isRowSelected ? theme.palette.text.secondary : theme.palette.text.placeholder};
      }

      svg {
        color: ${({ theme }) =>
          isRowSelected ? theme.palette.text.secondary : theme.palette.text.placeholder};
      }
    `}

  ${({ isEmpty, rowHeight, theme }) =>
    isEmpty &&
    css`
      min-height: ${rowHeight}px;
      width: 100vw;
      background-color: ${theme.colors.tableSelection};
      border-color: ${theme.colors.tableSelection};
      color: ${theme.palette.text.secondary};
    `}

  ${({ isStaticRow, theme }) =>
    isStaticRow &&
    css`
      background-color: ${theme.colors.tableSelection};
      border-color: ${theme.colors.tableSelection};
      color: ${theme.palette.text.secondary};
    `}

  :last-child {
    border-bottom: none;
  }
`;

interface WrapperProps {
  children?: ReactNode;
  id?: string;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex: 1 0 auto;
`;
